import { render, staticRenderFns } from "./import-list.vue?vue&type=template&id=1d5f8aba&"
import script from "./import-list.vue.ts?vue&type=script&lang=ts&"
export * from "./import-list.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports